import { SettingsScreen } from './SettingsScreen.jsx';

export default {
  path: '/settings',
  element: <SettingsScreen />,
  protected: true,
  anyPermission: [
    'settings.users.view',
    'settings.roles.view',
    'settings.audit.view',
    'settings.devices.manage',
    'system.manage'
  ],
  standalone: false,
  sidebar: { label: 'الإعدادات', icon: 'users', group: 'admin', order: 92 }
};
